/* eslint-disable */
import React from 'react';
import config from '../../../config/config.json';

const isElementWithId = (t: EventTarget): t is Element => 'id' in t;

export type Callbacks = {
  onEnter: () => void;
  onEscape: () => void;
  onTab: () => void;

  onEnterDown: (cursor: number) => void;
};

export const useKeyboardNavigation = (
  resultsNumber: number,
  submitOnEnter: boolean,
  callbacks: Callbacks,
) => {
  const [cursor, setCursor] = React.useState(-1);

  const handleKeyboardEvent = (event: KeyboardEvent) => {
    if (event.target && isElementWithId(event.target) && event.target.id === config.searchInputId) {
      switch (event.key) {
        case 'Down':
        case 'ArrowDown':
          event.preventDefault();
          setCursor((c) => Math.min(c + 1, resultsNumber - 1));
          break;
        case 'Up':
        case 'ArrowUp':
          event.preventDefault();
          setCursor((c) => Math.max(c - 1, -1));
          break;
        case 'Enter':
          event.preventDefault();
          if (submitOnEnter && cursor >= 0) {
            event.preventDefault();
            callbacks.onEnterDown(cursor);
          }
          break;
        case 'Esc':
        case 'Escape':
          callbacks.onEscape();
          break;
        case 'Tab':
          callbacks.onTab();
          break;
        default:
          break;
      }
    }
    switch (event.key) {
      case 'Enter':
        (event.target as HTMLElement).click();
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyboardEvent);
    return () => {
      document.removeEventListener('keydown', handleKeyboardEvent);
    };
  }, [resultsNumber, cursor]);

  return cursor;
};
